import React from 'react';
import OddsButton from '../../../../../OddsButton/OddsButton';
import { useDispatch, useSelector } from 'react-redux';
import {
    addBetSlipBetLine,
    deleteBetSlipBetLine,
} from '../../../../../../../store/actions/betSlip';
import { generateRegularBetLine } from '../../../../../../../utils/betSlip';

const Active = ({ event, market, outcomes }) => {
    const dispatch = useDispatch();

    const betLines = useSelector(state => state.betSlip.betLines);
    const producerStatuses = useSelector(state => state.feed.producerStatuses);

    const checkOddSelection = (outcomeId, marketId) => {
        return betLines.some(bet => bet.marketId === marketId && bet.outcomeId === outcomeId);
    };

    const addToBetSlip = outcome => {
        dispatch(addBetSlipBetLine(generateRegularBetLine({ event, market, outcome })));
    };

    const removeFromBetSlip = outcomeRefId => {
        const betLine = {
            eventId: event.id,
            marketId: market.id,
            outcomeId: outcomeRefId,
        };
        dispatch(deleteBetSlipBetLine(betLine));
    };

    return outcomes.length > 0
        ? outcomes.map(outcome => (
              <td key={outcome.outcomeRefId}>
                  <OddsButton
                      marketStatus={market.status}
                      outcomeStatus={outcome.status}
                      changeType={outcome.changeType}
                      odd={outcome.odd}
                      isFrozen={
                          market.frozen ||
                          (event.live && producerStatuses.isLiveDown) ||
                          (!event.live && producerStatuses.isPreMatchDown)
                      }
                      isClosed={
                          market.closed ||
                          market.status !== 0 ||
                          outcome.status !== 0 ||
                          outcome.closed
                      }
                      selected={checkOddSelection(outcome.outcomeRefId, market.id)}
                      addToSlip={() => addToBetSlip(outcome)}
                      removeFromSlip={() => removeFromBetSlip(outcome.outcomeRefId)}
                  />
              </td>
          ))
        : null;
};

export default Active;
